module.exports = __webpack_public_path__ + "img/list5.4861040f.png";